import { RootState } from '@reducers';

export const selectGeneralOrderPayment = (state: RootState) => state.generalOrderPaymentPageReducer;
